import React from "react";
import StatCard from "./StatCard";
import {
  CalendarOutlined,
  EnvironmentOutlined,
  GlobalOutlined,
} from "@ant-design/icons";

export const CumulativePerformance: React.FC = () => {
  const stats = [
    { label: "Total screened", value: "647", valueLabel: "sbjs" },
    {
      label: "Total screen failed",
      value: "441",
      valueLabel: "sbjs",
      subValue: "68.1% SF rate",
    },
    {
      label: "Total enrolled",
      value: "129",
      valueLabel: "sbjs",
      subValue: "19.9% success rate",
    },
    {
      label: "Total early terminations",
      value: "5",
      valueLabel: "sbjs",
      subValue: "3.8% dropout rate",
    },
    {
      label: "Total completed",
      value: "48",
      valueLabel: "sbjs",
    },
  ];

  return (
    <StatCard
      icon={<GlobalOutlined style={{ fontSize: "18px" }} />}
      iconBg="#D2ECF7"
      title="Cumulative Performance"
      subtitle="count, rate"
      stats={stats}
    />
  );
};

export const ThisMonthPerformance: React.FC = () => {
  const stats = [
    {
      label: "Total screened",
      value: "59",
      valueLabel: "sbjs",
      subValue: "58 last month (+1 sbj)",
    },
    {
      label: "Total screen failed",
      value: "30",
      valueLabel: "sbjs",
      subValue: "41 last month (-11 sbjs)",
    },
    {
      label: "Total enrolled",
      value: "2",
      valueLabel: "sbjs",
      subValue: "3 last month (-1 sbj)",
    },
    {
      label: "Total early terminations",
      value: "0",
      valueLabel: "sbjs",
      subValue: "0 last month (±0 sbj)",
    },
    {
      label: "Total Active",
      value: "76",
      valueLabel: "sbjs",
      subValue: "74 last month (+2 sbj)",
    },
  ];

  return (
    <StatCard
      icon={<CalendarOutlined style={{ fontSize: "18px" }} />}
      iconBg="#BDDBC6"
      title="This Month"
      subtitle="count, last month, change"
      stats={stats}
    />
  );
};

export const PerSitePerformance: React.FC = () => {
  const stats = [
    {
      label: "Total screened",
      value: "28.1",
      valueLabel: "sbjs/site",
      subValue: "± 5.6 std (range 15 - 41)",
    },
    {
      label: "Total screen failed",
      value: "19.2",
      valueLabel: "sbjs/site",
      subValue: "± 5.0 std (range 8 - 32)",
    },
    {
      label: "Total enrolled",
      value: "5.6",
      valueLabel: "sbjs/site",
      subValue: "± 2.23 std (range 2 - 10)",
    },
    {
      label: "Total early terminations",
      value: "0.22",
      valueLabel: "sbjs/site",
      subValue: "± 0.52 std (range 0 - 2)",
    },
    {
      label: "Total active",
      value: "3.3",
      valueLabel: "sbjs/site",
    },
  ];

  return (
    <StatCard
      iconBg="#E7D2DF"
      icon={<EnvironmentOutlined style={{ fontSize: "18px" }} />}
      title="Per Site"
      subtitle="avg, std, range"
      stats={stats}
    />
  );
};
